<h3
  *ngIf="!saleItemsOnBulkActions"
  class="mb-3"
  [hidden]="!(selectedProduct$ | async)?.description"
>
  {{ 'productModule.product' | translate }}:
  {{ (selectedProduct$ | async)?.description }}
</h3>
<h3
  *ngIf="saleItemsOnBulkActions"
  class="mb-3"
  [hidden]="
    !(productEntities$ | async)[saleItemsOnBulkActions[0].productId]
      ?.description
  "
>
  {{ 'productModule.product' | translate }}:
  {{
    (productEntities$ | async)[saleItemsOnBulkActions[0].productId]?.description
  }}
</h3>
<form
  [formGroup]="form"
  (ngSubmit)="onFormSubmit()"
  [patchForm]="saleItem"
  #formRef="ngForm"
>
  <div class="row">
    <div
      class="mb-4 col-sm-3"
      [hidden]="
        saleItem.subscriptionId ||
        (saleItemService.getSaleItemParticipants$(saleItem) | async)[0]
          ?.saleItemId == saleItem.id
      "
    >
      <ng-container *ngIf="!(isBookableProductForm$ | async)">
        <span
          [ngClass]="{
            'form-check': saleItemsOnBulkActions
          }"
        >
          <span *ngIf="saleItemsOnBulkActions">
            <input
              type="checkbox"
              class="form-check-input"
              [checked]="bulkEditFieldsChanges.quantity"
              (change)="onCheckRow('quantity')"
              id="changesQuantity"
            />
          </span>

          <label
            [ngClass]="
              saleItemsOnBulkActions ? 'form-check-label' : 'form-label'
            "
            for="changesQuantity"
          >
            {{ 'general.quantity' | translate }}
          </label>
        </span>

        <input
          [readonly]="isSalePaid"
          type="number"
          class="form-control"
          placeholder="1"
          formControlName="quantity"
        />
        <p
          class="invalid-feedback"
          role="alert"
          aria-atomic="true"
          *ngIf="form.controls.quantity.dirty && form.controls.quantity.invalid"
        >
          {{ 'general.quantity' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </ng-container>
    </div>
    <div class="mb-4 col">
      <span
        [ngClass]="{
          'form-check': saleItemsOnBulkActions
        }"
      >
        <span *ngIf="saleItemsOnBulkActions">
          <input
            type="checkbox"
            class="form-check-input"
            [checked]="bulkEditFieldsChanges.customerCategory"
            (change)="onCheckRow('customerCategory')"
            id="changesCustomerCategory"
          />
        </span>
        <label
          [ngClass]="saleItemsOnBulkActions ? 'form-check-label' : 'form-label'"
          for="changesCustomerCategory"
        >
          {{ 'saleModule.customerCategory' | translate }}
        </label>
      </span>

      <select formControlName="customerCategory" class="form-select">
        <option
          *ngFor="let cat of this.categories$ | async"
          value="{{ getCategoryValue(cat) }}"
        >
          {{ cat | getCategoryDescription | async }}
        </option>
      </select>

      <p
        class="invalid-feedback"
        role="alert"
        aria-atomic="true"
        *ngIf="
          form.controls.customerCategory.dirty &&
          form.controls.customerCategory.invalid
        "
      >
        {{ 'saleModule.customerCategory' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>
  </div>
  <div class="row">
    <div class="mb-4 col-sm-3" *ngIf="isSalePaid">
      <label
        class="form-label"
        for="quantityToReduce"
      >
        {{ 'saleModule.quantityToReduce' | translate }}
      </label>
      <input
        id="quantityToReduce"
        type="number"
        class="form-control"
        placeholder="0"
        formControlName="quantityToReduce"
      />
      <p
        class="invalid-feedback"
        role="alert"
        aria-atomic="true"
        *ngIf="form.controls.quantityToReduce.dirty && form.controls.quantityToReduce.invalid"
      >
        {{ 'saleModule.quantityToReduce' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>
  </div>

  <div
    *ngIf="!saleItemsOnBulkActions"
    [hidden]="
      (isBookableProductForm$ | async) ||
      (saleItemBookingItems$ | async)?.length > 0 ||
      (saleItemService.getSaleItemParticipants$(saleItem) | async)?.length ||
      saleItem.subscriptionId ||
      (!(productEntities$ | async)[saleItem?.productId]?.allowAsLinkedProduct &&
        !(productEntities$ | async)[saleItem?.productId]?.bookable)
    "
    class="mb-4"
  >
    <label class="form-label">
      {{ 'saleModule.linkToBooking' | translate }}
    </label>
    <ng-select
      style="height: auto !important"
      *ngIf="saleBookings$ | async"
      [items]="saleBookings$ | async | saleBookingLinkItemMap | async"
      [multiple]="false"
      [closeOnSelect]="true"
      [searchable]="true"
      bindLabel="description"
      bindValue="id"
      placeholder="{{ 'general.select' | translate }}"
      formControlName="bookingItemsId"
      [clearSearchOnAdd]="true"
    >
      <ng-template ng-label-tmp ng-option-tmp let-item="item">
        <p class="text-truncate mb-0">
          {{ item.description }}
        </p>
        <small class="text-muted">
          {{
            item.startDate
              | date : 'EEEE d MMMM' : null : (selectedLanguage$ | async)
          }}
          -
          {{
            item.endDate
              | date : 'EEEE d MMMM' : null : (selectedLanguage$ | async)
          }}
        </small>
      </ng-template>
    </ng-select>

    <button
      type="button"
      class="btn btn-ghost-primary btn-sm mt-2"
      [disabled]="!form.controls.bookingItemsId?.value"
      (click)="linkToBooking($event)"
    >
      <i role="img" class="fa fa-plus-circle" aria-hidden="true"></i>
      {{ 'saleModule.attachSelectedBooking' | translate }}
    </button>

    <p
      class="invalid-feedback"
      role="alert"
      aria-atomic="true"
      *ngIf="
        form.controls.bookingItemsId.dirty &&
        form.controls.bookingItemsId.invalid
      "
    >
      {{ 'saleModule.linkToBooking' | translate }}
      {{ 'general.isInvalid' | translate }}
    </p>
  </div>
  <ng-container
    *ngIf="
      !(
        (isBookableProductForm$ | async) ||
        (saleItemService.getSaleItemParticipants$(saleItem) | async)?.length > 0
      ) && !saleItem.subscriptionId
    "
  >
    <div class="row">
      <fieldset class="mb-4 col-lg-auto">
        <legend class="form-label" for="changesEndTime">
          {{ 'general.startDateEndTime' | translate }}
        </legend>

        <div class="d-flex gap-2 align-items-center">
          <span *ngIf="saleItemsOnBulkActions">
            <input
              type="checkbox"
              class="form-check-input"
              [checked]="bulkEditFieldsChanges.startDate"
              (change)="onCheckRow('startDate')"
              id="changesEndTime"
            />
          </span>
          <datetime-input
            [hideTime]="true"
            formControlName="startDate"
          ></datetime-input>
          <span *ngIf="saleItemsOnBulkActions">
            <input
              type="checkbox"
              class="form-check-input"
              [checked]="bulkEditFieldsChanges.startTime"
              (change)="onCheckRow('startTime')"
            />
          </span>
          <nz-time-picker
            formControlName="startTime"
            nzFormat="HH:mm"
            nzMinuteStep="15"
          ></nz-time-picker>

          <p
            class="invalid-feedback"
            role="alert"
            aria-atomic="true"
            *ngIf="
              (form.controls.startDate.dirty &&
                form.controls.startDate.invalid) ||
              (form.controls.startTime.dirty && form.controls.startTime.invalid)
            "
          >
            {{ 'general.startDateEndTime' | translate }}
            {{ 'general.isInvalid' | translate }}
          </p>
        </div>
      </fieldset>
      <fieldset class="mb-4 col-lg-auto">
        <legend class="form-label">
          {{ 'bookingModule.setEndTime' | translate }}
        </legend>

        <div class="d-flex gap-2 align-items-center">
          <span *ngIf="saleItemsOnBulkActions">
            <input
              type="checkbox"
              class="form-check-input"
              [checked]="bulkEditFieldsChanges.endTime"
              (change)="onCheckRow('endTime')"
            />
          </span>
          <nz-time-picker
            [nzDisabledHours]="disabledHours(form.get('startTime').value)"
            formControlName="endTime"
            nzFormat="HH:mm"
            nzMinuteStep="15"
          ></nz-time-picker>

          <p
            class="invalid-feedback"
            role="alert"
            aria-atomic="true"
            *ngIf="
              form.controls.startTime.dirty && form.controls.startTime.invalid
            "
          >
            {{ 'general.startDateEndTime' | translate }}
            {{ 'general.isInvalid' | translate }}
          </p>
        </div>
      </fieldset>
    </div>
  </ng-container>

  <div class="mb-4">
    <span
      [ngClass]="{
        'form-check': saleItemsOnBulkActions
      }"
    >
      <span *ngIf="saleItemsOnBulkActions">
        <input
          type="checkbox"
          class="form-check-input"
          [checked]="bulkEditFieldsChanges.bookableProductId"
          (change)="onCheckRow('bookableProductId')"
          id="changesBookableProduct"
        />
      </span>
      <label
        [ngClass]="saleItemsOnBulkActions ? 'form-check-label' : 'form-label'"
        *ngIf="
          (saleItemService.getSaleItemParticipants$(saleItem) | async)[0]
            ?.saleItemId != saleItem.id
        "
        for="changesBookableProduct"
      >
        {{ 'bookingModule.selectResource' | translate }}
      </label>
      <label
        [ngClass]="saleItemsOnBulkActions ? 'form-check-label' : 'form-label'"
        *ngIf="
          (saleItemService.getSaleItemParticipants$(saleItem) | async)[0]
            ?.saleItemId == saleItem.id
        "
        for="changesBookableProduct"
      >
        {{ 'productModule.resources' | translate }}
      </label>
    </span>

    <product-select-input
      [products]="productResources$ | async"
      [dropdownPosition]="'top'"
      (search)="onSearchProducts($event)"
      formControlName="bookableProductId"
      [isDisabled]="
        (productEntities$ | async)[saleItem?.productId]?.allowAsLinkedProduct ||
        (productEntities$ | async)[saleItem?.productId]?.bookable
      "
      [allowClearing]="true"
      [isFromBookingSaleCreation]="true"
    ></product-select-input>
    <p
      class="invalid-feedback"
      role="alert"
      aria-atomic="true"
      *ngIf="
        form.controls.bookableProductId.dirty &&
        form.controls.bookableProductId.invalid
      "
    >
      {{ 'bookingModule.selectResource' | translate }}
      {{ 'general.isInvalid' | translate }}
    </p>
  </div>
  <div
    *ngIf="
      (saleItemBookingItems$ | async)?.length > 0 && !saleItemsOnBulkActions
    "
    class="row"
  >
    <table class="table">
      <thead>
        <tr>
          <th scope="col">{{ 'bookingModule.booking' | translate }} ID</th>
          <th scope="col">{{ 'general.description' | translate }}</th>
          <th scope="col">{{ 'general.startDate' | translate }}</th>
          <th scope="col">{{ 'general.time' | translate }}</th>
          <th scope="col">{{ 'general.action' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of saleItemBookingItems$ | async">
          <ng-container
            *ngIf="(bookingEntities$ | async)[data.bookingId] as booking"
          >
            <td>
              <a [routerLink]="['/bookings', booking.id]" target="_blank">
                {{ booking.id }}
              </a>
            </td>
            <td>
              {{ booking?.description }} -
              {{ (productEntities$ | async)[booking?.productId]?.description }}
            </td>

            <td>
              {{
                data.startDate
                  | date
                    : 'EEEE d MMMM yyyy'
                    : null
                    : (selectedLanguage$ | async)
              }}
            </td>
            <td *ngIf="editingBookingItemId !== data.id">
              {{ data.startDate | date : 'HH:mm' }}
            </td>
            <td *ngIf="editingBookingItemId === data.id">
              <nz-time-picker
                formControlName="selectedBookingItemsTime"
                nzFormat="HH:mm"
                nzMinuteStep="15"
              ></nz-time-picker>
            </td>

            <td *ngIf="editingBookingItemId !== data.id">
              <a
                href="javascript:;"
                nz-popconfirm
                nzPopconfirmTitle="{{ 'general.areYouSure' | translate }}"
                nzPopconfirmPlacement="bottom"
                (nzOnConfirm)="removeBookingItem(data)"
                class="btn btn-sm btn-soft-danger me-2"
              >
                {{ 'general.delete' | translate }}
              </a>

              <button
                type="button"
                class="btn btn-sm btn-soft-primary"
                (click)="$event.preventDefault(); editBookingItem(data)"
              >
                {{ 'general.edit' | translate }}
              </button>
            </td>
            <td
              class="d-flex justify-content-around"
              *ngIf="editingBookingItemId === data.id"
            >
              <button
                class="btn btn-sm btn-primary"
                type="button"
                (click)="updateBookingItem(data)"
              >
                {{ 'general.save' | translate }}
              </button>
              <button
                class="ms-1 btn btn-sm btn-primary"
                type="button"
                (click)="cancelEditBookingItem()"
              >
                {{ 'general.cancel' | translate }}
              </button>
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="mb-4">
    <span
      [ngClass]="{
        'form-check': saleItemsOnBulkActions
      }"
    >
      <span *ngIf="saleItemsOnBulkActions">
        <input
          type="checkbox"
          class="form-check-input"
          [checked]="bulkEditFieldsChanges.tags"
          (change)="onCheckRow('tags')"
          id="changesTags"
        />
      </span>
      <label
        [ngClass]="saleItemsOnBulkActions ? 'form-check-label' : 'form-label'"
        for="changesTags"
      >
        {{ 'tagModule.tags' | translate }}
      </label>
    </span>

    <ng-select
      *ngIf="tags"
      [items]="filteredTags"
      [multiple]="true"
      [closeOnSelect]="false"
      [searchable]="true"
      [compareWith]="compareWith"
      [(ngModel)]="tagsInProduct"
      bindLabel="description"
      bindValue="id"
      placeholder="{{ 'tagModule.selectTag' | translate }}"
      formControlName="tags"
      [clearSearchOnAdd]="true"
      [dropdownPosition]="'top'"
    >
    </ng-select>
    <p
      class="invalid-feedback"
      role="alert"
      aria-atomic="true"
      *ngIf="form.controls.tags.dirty && form.controls.tags.invalid"
    >
      {{ 'tagModule.tags' | translate }}
      {{ 'general.isInvalid' | translate }}
    </p>
  </div>
  <sale-item-purchase-params-form
    [hidden]="
      (saleItemService.getSaleItemParticipants$(saleItem) | async)?.length ||
      saleItem.bookingId ||
      !saleItem?.params?.bookableProductId ||
      !saleItem?.params?.bookableLinkedProductId ||
      saleItemsOnBulkActions
    "
    [params]="saleItem.params"
    [selectedProduct]="(productEntities$ | async)[saleItem?.productId]"
  ></sale-item-purchase-params-form>

  <div
    class="mb-4"
    [hidden]="
      (getParticipationsCount$() | async).total <= 0 || saleItemsOnBulkActions
    "
  >
    <span>
      <p *ngIf="!saleItem.bookingId">
        {{ 'participationModule.allows' | translate }}&nbsp;
        {{ (getParticipantLimits$() | async).maxParticipants }}&nbsp;
        {{ 'bookingModule.participants' | translate }}
      </p>
      <p
        *ngIf="
          saleItem.bookingId &&
          existCurrentparticipant(
            (bookingEntities$ | async)[saleItem.bookingId]
          )
        "
      >
        {{ 'participationModule.currentParticipations' | translate }}&nbsp;
        {{
          (bookingEntities$ | async)[saleItem.bookingId]
            .currentParticipantCount
        }}/{{
          (bookingEntities$ | async)[saleItem.bookingId]
            .availableParticipantCount +
            (bookingEntities$ | async)[saleItem.bookingId]
              .currentParticipantCount
        }}&nbsp;-&nbsp;
        {{ 'participationModule.allows' | translate | titlecase }}&nbsp;
        {{
          (bookingEntities$ | async)[saleItem.bookingId]
            .availableParticipantCount
        }}&nbsp; {{ 'bookingModule.participants' | translate }}
      </p>
      <p
        *ngIf="
          saleItem.bookingId &&
          !existCurrentparticipant(
            (bookingEntities$ | async)[saleItem.bookingId]
          )
        "
      >
        {{ 'participationModule.allows' | translate | titlecase }}&nbsp;
        {{
          (
            participationService.getParticipantCounts$(
              null,
              saleItem.bookingId,
              null
            ) | async
          ).spotsLeft ?? (getParticipantLimits$() | async).maxParticipants
        }}&nbsp; {{ 'bookingModule.participants' | translate }}
      </p>
    </span>

    <ul class="list-unstyled ps-4" *ngIf="showItem$ | async">
      <li>
        <sale-item-adjust-participations-by-type
          [type]="participationType.GUEST"
          [saleItem]="saleItem"
          [participantsLimits]="getParticipantLimits$() | async"
          (haveVisibleFather)="isFatherVisible($event)"
        ></sale-item-adjust-participations-by-type>
      </li>
      <li>
        <sale-item-adjust-participations-by-type
          [type]="participationType.OTHER"
          [saleItem]="saleItem"
          [participantsLimits]="getParticipantLimits$() | async"
          (haveVisibleFather)="isFatherVisible($event)"
        ></sale-item-adjust-participations-by-type>
      </li>
      <li>
        <sale-item-adjust-participations-by-type
          [type]="participationType.MEMBER"
          [saleItem]="saleItem"
          [participantsLimits]="getParticipantLimits$() | async"
          (haveVisibleFather)="isFatherVisible($event)"
        ></sale-item-adjust-participations-by-type>
      </li>
    </ul>
  </div>

  <div
    class="spinner-border my-5 mx-auto d-block"
    role="status"
    *ngIf="isLoadingBookings$ | async"
    attr.aria-label="{{ 'general.loading' | translate }}"
  >
  </div>

  <form
    *ngIf="
      saleModuleConfig.cancelationPolicy &&
      (cancellationPoliciesAvailableBySaleItem$ | async)?.length > 0 &&
      (hasQuantityReduced$ | async)
    "
    [formGroup]="cancelationForm"
  >
    <!-- Cancel button, multi flow ENABLED  -->
    <div class="mb-4">
      <label
        [ngClass]="saleItemsOnBulkActions ? 'form-check-label' : 'form-label'"
      >
        {{ 'saleModule.cancelationPolicy' | translate }}
      </label>
      <select
        formControlName="cancelationPolicyUuid"
        class="form-select"
        [attr.aria-invalid]="
          cancelationForm.controls.cancelationPolicyUuid.dirty &&
          cancelationForm.controls.cancelationPolicyUuid.invalid
            ? 'true'
            : null
        "
      >
        <option
          *ngFor="
            let cancellationPolicy of cancellationPoliciesAvailableBySaleItem$
              | async
          "
          [value]="cancellationPolicy.cancellationPolicyId"
        >
          {{
            cancellationPolicy['title_' + ((selectedLanguage$ | async) || 'en')] ||
              cancellationPolicy['title_en']
          }}
        </option>
      </select>
    </div>
  </form>

  <div class="form-footer">
    <div
      class="spinner-border"
      role="status"
      attr.aria-label="{{ 'general.loading' | translate }}"
      *ngIf="isLoading$ | async"
    >
    </div>

    <button
      [hidden]="
        !hideCancelationForm || (isLoading$ | async) || saleItemsOnBulkActions
      "
      class="btn btn-warning"
      (click)="onPreconfirmDelete()"
      type="button"
    >
      {{ 'general.delete' | translate }}
      {{ 'saleModule.sale' | translate }}
      {{ 'general.item' | translate }}
    </button>

    <button
      *ngIf="saleModuleConfig.cancelationPolicy"
      [hidden]="(isLoading$ | async) || hideCancelationForm"
      class="mt-3 btn btn-danger"
      (click)="onDelete()"
      type="button"
    >
      {{ 'general.approve' | translate }} {{ 'general.delete' | translate }}
    </button>

    <button
      [hidden]="(isLoading$ | async) || !hideCancelationForm"
      *ngIf="showSubmitButton"
      class="btn btn-primary"
      type="submit"
      [disabled]="form.invalid || form.untouched || !saveButtonAvailable"
    >
      {{ 'general.save' | translate }}
    </button>
  </div>
</form>
